import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Loader2, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function MobileLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(username, password);
      if (u.role === "client") { setError("Staff-only app. Client accounts cannot sign in."); setLoading(false); return; }
      toast.success(`Welcome back, ${u.name.split(" ")[0]}!`);
      nav("/m", { replace: true });
    } catch (err) { setError(apiErr(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0b1220] via-[#123a63] to-[#3a1d6e] flex flex-col justify-center px-6 py-10 relative overflow-hidden">
      <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-[hsl(var(--brand-blue))] opacity-25 blur-3xl" />
      <div className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-[hsl(var(--brand-orange))] opacity-20 blur-3xl" />
      <img src="/logo.png" alt="" aria-hidden="true" className="pointer-events-none select-none absolute -right-10 bottom-16 w-72 opacity-[0.10] rotate-6" />

      <div className="relative w-full max-w-sm mx-auto animate-fadeup">
        <div className="flex items-center gap-2.5 mb-8">
          <img src="/logo.png" alt="Chahal Overseas" className="h-11 w-auto object-contain" />
          <div className="leading-none">
            <div className="font-head font-extrabold text-xl text-white">Chahal <span className="text-[hsl(var(--brand-blue))]">Overseas</span></div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-300">Immigration · Staff App</div>
          </div>
        </div>

        <h1 className="font-head font-extrabold text-2xl text-white mb-1">Staff sign in</h1>
        <p className="text-slate-300 text-sm mb-6">Your CRM, in your pocket.</p>

        {error && <div className="mb-4 text-sm bg-rose-500/15 text-rose-200 border border-rose-400/30 rounded-xl px-4 py-3" data-testid="mlogin-error">{error}</div>}

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-semibold text-slate-200 uppercase tracking-wide">Username</label>
            <input data-testid="mlogin-username" type="text" autoCapitalize="none" autoCorrect="off" required value={username} onChange={(e) => setUsername(e.target.value)}
              className="mt-1.5 w-full px-4 py-3 rounded-xl bg-white/95 border border-white/20 focus:outline-none focus:ring-2 focus:ring-[hsl(var(--brand-blue))]" placeholder="your username" />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-200 uppercase tracking-wide">Password</label>
            <input data-testid="mlogin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 w-full px-4 py-3 rounded-xl bg-white/95 border border-white/20 focus:outline-none focus:ring-2 focus:ring-[hsl(var(--brand-blue))]" placeholder="••••••••" />
          </div>
          <button data-testid="mlogin-submit" disabled={loading} className="w-full bg-primary text-white py-3 rounded-xl font-semibold hover:bg-primary/90 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Sign in <ArrowRight className="h-4 w-4" /></>}
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-slate-400">Forgot your password? Contact your administrator.</p>
      </div>
    </div>
  );
}
